module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('h3', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('settings.attributes.payment_methods')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('settings.label.configure_new')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ls-float-right ls-md-margin-bottom"
  }, [_c('router-link', {
    staticClass: "ls-btn-primary",
    attrs: {
      "to": '/settings/payment_settings/' + _vm.processor + '/new'
    }
  }, [_vm._v(_vm._s(_vm.$t('settings.label.buttons.add_payment_method')))])], 1)]), _vm._v(" "), _vm._l((_vm.types), function(type) {
    return _c('div', {
      staticClass: "ls-float-right col-md-12"
    }, [(type) ? _c('payment-list', {
      attrs: {
        "type": type
      }
    }) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "ls-actions-btn col-md-12"
  }, [_c('router-link', {
    staticClass: "ls-btn ls-float-right",
    attrs: {
      "to": "/settings/payment_settings/index",
      "title": _vm.$t('application.menu.payment_settings')
    }
  }, [_vm._v(_vm._s(_vm.$t('application.button.back')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e33a5d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/settings/ShowPaymentSettings.vue
// module id = 787
// module chunks = 1